<template>
  <component
    :is="tag"
    ref="cell"
    v-bind:class="classes"
    :tabindex="tab"
    contenteditable="false"
    @blur="blurCell"
    @click="clickDescription"
    @keydown="keydownCell($event)"
    v-text="value"></component>
</template>

<script>
import inputHelpers from '@/helpers/inputHelpers'

export default {
  name: 'beam-table-cell',

  props: {
    cell: Boolean,
    verb: Boolean,
    isReadModel: Boolean,
    header: Boolean,
    headerAfterVerb: Boolean,
    dimensionData: Boolean,
    list: Boolean,
    tab: Number,
    tag: {
      type: String,
      default: 'td'
    },
    value: String
  },

  methods: {
    blurCell (event) {
      if (event.target.innerText.length > 30) {
        alert('Data field must be max 30 characters')
        this.restoreValue(event, this.value)
        return
      }

      event.target.setAttribute('contenteditable', 'false')
      this.$emit('blur-table-cell', event)
    },
    clickDescription (event) {
      if (this.$store.state.isWorkflowDisabled === false) {
        const contenteditable = event.target.getAttribute('contenteditable')
        if (contenteditable !== 'true') {
          event.target.setAttribute('contenteditable', 'true')
          event.target.focus()
        }
      }
    },
    isPrintableCharacter (keycode) {
      const printable =
        (keycode > 47 && keycode < 58) || // number keys
        keycode === 32 || keycode === 13 || // spacebar & return key(s) (if you want to allow carriage returns)
        (keycode > 64 && keycode < 91) || // letter keys
        (keycode > 95 && keycode < 112) || // numpad keys
        (keycode > 185 && keycode < 193) || // ;=,-./` (in order)
        (keycode > 218 && keycode < 223) // [\]' (in order)
      return printable
    },
    keydownCell (event) {
      switch (event.keyCode) {
        case 13: // enter
          if (event.target.getAttribute('contenteditable') === 'true') {
            this.$emit('leave-cell', event)
          } else {
            event.target.setAttribute('contenteditable', 'true')
            event.target.focus()
            inputHelpers.moveCursorToTextEnd(event.target)
            event.preventDefault()
          }
          break
        case 27: // escape
          this.restoreValue(event, this.value)
          break
        case 37: // left
        case 38: // up
        case 39: // right
        case 40: // down
          if (event.target.getAttribute('contenteditable') !== 'true') {
            this.$emit('leave-cell', event)
          }
          break
        default:
          if (!this.$store.state.isWorkflowDisabled && event.target.getAttribute('contenteditable') !== 'true' && this.isPrintableCharacter(event.keyCode) && !event.altKey && !event.metaKey) {
            event.target.setAttribute('contenteditable', 'true')
            event.target.innerText = ''
            event.target.focus()
            inputHelpers.moveCursorToTextEnd(event.target)
          }
      }
      event.stopPropagation()
    },
    restoreValue (event, value) {
      if (event.target.isContentEditable) {
        event.target.innerText = value
        inputHelpers.moveCursorToTextEnd(event.target)
      }
    },
    setFocus () {
      this.$refs.cell.focus()
    }
  },
  computed: {
    classes () {
      return {
        'btc-cell': this.cell,
        'list-cell': this.list,
        'bg-orange-lighten-5': this.dimensionData,
        'btc-header-cell': this.header,
        'btc-header-cell-verb': this.verb,
        'btc-header-after-verb': this.headerAfterVerb,
        'bg-green-lighten-4': this.isReadModel
      }
    }
  }
}
</script>

<style>
div {
  outline: none !important;
}

.btc-cell {
  font-size: 14px !important;
  padding: 9px 16px !important;
  border-right: 1px solid #E5E3E1;
}

.list-cell {
  &::before {
    content: 'List: ';
    font-size: 12px;
    color: #9e9e9e;
    vertical-align: bottom;
  }
}

td.btc-cell.orange.lighten-5 {
  border-color: rgba(0,0,0,.12);
  border-bottom: thin solid rgba(0,0,0,.12) !important;
}

.btc-header-cell {
  width: 100%;
  height: 100%;
  font-size: 16px;
  font-weight: 500;
  line-height: 36px;
  padding: 8px 12px;
  background-color: var(--blue-2);
  color: var(--text-dark, #1F2833);
  white-space: nowrap;
}

.btc-header-after-verb{
  height: 100%;
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  padding: 4px 12px;
  background-color: var(--blue-2);
  color: var(--text-dark, #1F2833);
}

.btc-header-cell-verb {
  height: 100%;
  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
  padding: 14px 12px 4px;
  background-color: var(--blue-2);
  color: var(--text-light, #4F5359);
}
</style>
